import React from 'react';
import { useCountdown } from './useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-brand-purple text-white py-3 px-4 text-center sticky top-0 z-50 shadow-md pt-[1px] pb-[1px] pl-[13px] pr-[13px]" data-id="element-310">
      <p className="text-sm md:text-base font-semibold flex items-center justify-center gap-2 flex-wrap" data-id="element-311">
        <span data-id="element-312">⚠️ PRECIO DE LANZAMIENTO CIERRA EN:</span>
        <span className="bg-white/20 px-2 py-1 rounded font-mono tracking-wider" data-id="element-313">
          {hours}h : {minutes}m : {seconds}s
        </span>
      </p>
    </div>;
}